let quickCartRevision=0;
document.addEventListener('click',event=>{
  const close=event.target.closest('.quick-close');
  if(close){const details=close.closest('[data-quick-details]');details.open=false;details.querySelector('summary').focus();}
});
document.addEventListener('keydown',event=>{
  const details=event.target.closest('[data-quick-details]');
  if(details&&event.key==='Escape'){details.open=false;details.querySelector('summary').focus();}
});
document.addEventListener('change',event=>{
  const input=event.target;
  const parentForm=input.closest('.quick-add-form,.product-form');
  if(parentForm&&parentForm.dataset.busy!=='true'){const button=parentForm.querySelector('.quick-submit,[data-add]');if(button&&!button.disabled)button.textContent=button.dataset.label;}
  if(!input.matches('.quick-add-form input[type="radio"][name="id"]'))return;
  const card=input.closest('.product-card');
  card.querySelector('[data-card-price]').textContent=input.dataset.price;
  const compare=card.querySelector('[data-card-compare]');
  compare.textContent=input.dataset.compare;
  compare.hidden=!input.dataset.compare;
});
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches('.quick-add-form,.product-form'))return;
  if(form.matches('.product-form')&&event.submitter&&!event.submitter.matches('[data-add]'))return;
  event.preventDefault();
  if(form.dataset.busy==='true')return;
  if(!form.reportValidity())return;
  const panel=form.closest('.quick-panel,.product-info');
  const card=form.closest('.product-card,.product-info');
  const status=card.querySelector('[data-quick-status]');
  const bag=card.querySelector('[data-quick-bag]');
  const button=form.querySelector('.quick-submit,[data-add]');
  const payload=new FormData(form);
  let added=false;
  form.dataset.busy='true';form.setAttribute('aria-busy','true');
  button.disabled=true;button.textContent=panel.dataset.adding;
  status.textContent='';bag.hidden=true;
  try{
    const response=await fetch(panel.dataset.addUrl,{method:'POST',body:payload,headers:{Accept:'application/json'}});
    const result=await response.json();
    if(!response.ok){status.textContent=typeof result.description==='string'?result.description:panel.dataset.error;bag.hidden=false;return;}
    added=true;
    status.textContent=panel.dataset.added;bag.hidden=false;
    const details=form.closest('[data-quick-details]');if(details){details.open=false;details.querySelector('summary').focus();}
    const revision=++quickCartRevision;
    try{
      const cartResponse=await fetch(panel.dataset.cartUrl,{headers:{Accept:'application/json'},cache:'no-store'});
      if(cartResponse.ok){const cart=await cartResponse.json();if(revision===quickCartRevision){
        document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);
        document.querySelectorAll('[data-cart-link]').forEach(node=>node.setAttribute('aria-label',node.dataset.cartLabel+' ('+cart.item_count+')'));
      }}
    }catch{}
  }catch{
    status.textContent=panel.dataset.uncertain;bag.hidden=false;
  }finally{
    delete form.dataset.busy;form.removeAttribute('aria-busy');
    const selected=form.querySelector('[data-variant-select]')?.selectedOptions[0];
    button.disabled=selected?.dataset.available==='false';
    const current=new FormData(form);
    const unchanged=current.get('id')===payload.get('id')&&current.get('quantity')===payload.get('quantity');
    button.textContent=button.disabled?button.dataset.soldText:(added&&unchanged?panel.dataset.thanks:button.dataset.label);
  }
});
